import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import {
  authorizedGet,
  authorizedPost,
} from "../../../Config/networkWithToken";
import configuration from "../../../Config/configuration";
import MessageBar, {
  config,
  DOBASEURL,
  errorNotify,
  getValueFromLocalStorage,
  localStorageKey,
  successNotify,
} from "../../../utils/helper";
import Spinner from "../../../Components/Spinner/Spinner";
import Strings from "../../../utils/Strings";
import { MdDoubleArrow, MdHistory } from "react-icons/md";
import { FaUserCheck } from "react-icons/fa6";
import { FaUserTimes } from "react-icons/fa";
import "./UserRequest.css";
import Images from "../../../utils/images";
import { ImCancelCircle } from "react-icons/im";
import { IoIosSearch } from "react-icons/io";
import AdvanceSearch from "../../../Components/AdvanceSearch/AdvanceSearch";
import RejectModel from "../../../Components/RejectModel/RejectModel";
import { FaEdit } from "react-icons/fa";
import { useQuery, useQueryClient } from "@tanstack/react-query";
import UserRequestCard from "../../../Components/UserRequestCard/UserRequestCard";
import { QUESTIONNAIRE_REQUESTS_KEY } from "../QuestionnnaireRequest/QuesttionnnaireRequest";


const processAndSetData = (
  data,
  {
    setUserRequestData,
    setAcceptedRequest,
    setRejectedRequest,
    setMutuallyAcceptedRequest,
    setUserRejectedRequest,
    setPendingInTalkRequest,
  },
) => {
  const pending = [];
  const accepted = [];
  const rejected = [];
  const mutuallyAccepted = [];
  const userRejected = [];
  const pendingInTalk = [];

  data.forEach((value) => {
  
    if (value?.inTalk === true) {
      pendingInTalk.push(value);
    } else if (
      value?.requestStatus === "Accepted" &&
      value?.adminApproval === true &&
      value?.userApproval === true
    ) {
      mutuallyAccepted.push(value);
    } else if (value?.adminApproval === true && value?.userReject === true) {
      userRejected.push(value);
    } else if (value?.requestStatus === "Pending") {
      pending.push(value);
    } else if (value?.requestStatus === "Accepted") {
      accepted.push(value);
    } else if (value?.requestStatus === "Rejected") {
      rejected.push(value);
    }
  });

  setUserRequestData(pending);
  setAcceptedRequest(accepted);
  setRejectedRequest(rejected);
  setMutuallyAcceptedRequest(mutuallyAccepted);
  setUserRejectedRequest(userRejected);
  setPendingInTalkRequest(pendingInTalk);
};

const RequestCards = ({
  request,
  activeTab,
  index,
  adminId,
  setUserRequestData,
  setAcceptedRequest,
  setRejectedRequest,
  setMutuallyAcceptedRequest,
  setUserRejectedRequest,
  setRequests,
  setPendingInTalkRequest,
}) => {
  const queryClient = useQueryClient();

  const [loadingAcceptRequestId, setLoadingAcceptRequestId] = useState(null);
  const [loadingDenyRequestId, setLoadingDenyRequestId] = useState(null);
  const [isCommentSectionOpen, setIsCommentSectionOpen] = useState(false);
  const [comment, setComment] = useState("");
  const [error, setError] = useState(false);
  const [requestedId, setRequestedId] = useState(null);
  const [showRejectRevokeConfirmation, setShowRejectRevokeConfirmation] =
    useState(false);
  const [revoking, setRevoking] = useState(false);
  const [rejectCommentUpdate, setRejectCommentUpdate] = useState(false);
  const [inTalkLoading, setInTalkLoading] = useState(false);
  const role = getValueFromLocalStorage(localStorageKey.USERDATA, "role");
  const canManage = role === "admin" || role === "superAdmin";

  const setters = {
    setUserRequestData,
    setAcceptedRequest,
    setRejectedRequest,
    setMutuallyAcceptedRequest,
    setUserRejectedRequest,
    setPendingInTalkRequest,
  };

  const handleApproval = async (decision, requestId) => {
    try {
      if (decision === "approve") {
        setLoadingAcceptRequestId(requestId);
      } else {
        setLoadingDenyRequestId(requestId);
      }

      const data = {
        adminId: adminId,
        requestId: requestId,
        action: decision === "approve" ? Strings.APPROVE : Strings.REJECT,
        comments: comment,
        isCommentChange: rejectCommentUpdate,
      };

      const res = await authorizedPost(
        configuration.apis.adminApproval,
        data,
        config,
      );
      const response = res?.data?.data;

      if (res?.data?.status) {
        successNotify(res?.data?.message);
        setRequests(response);
        processAndSetData(response, setters);
        queryClient.invalidateQueries({ queryKey: ["userRequests", adminId] });
      } else {
        errorNotify(res?.data?.message);
      }
    } catch (error) {
      errorNotify(Strings.ERROR);
      console.log(error);
    } finally {
      setLoadingAcceptRequestId(null);
      setLoadingDenyRequestId(null);
      setRejectCommentUpdate(false);
    }
  };

  const handleInTalk = async (inTalk) => {
    setInTalkLoading(true);
    try {
      const data = {
        adminId,
        requestId: request._id,
        inTalk,
        inTalkFromTab: inTalk ? activeTab : request.inTalkFromTab,
      };
      const res = await authorizedPost(
        configuration.apis.inTalkStatus,
        data,
        config,
      );
      if (res?.data?.status) {
        successNotify(res?.data?.message);
        setRequests(res.data.data);
        processAndSetData(res.data.data, setters);
        queryClient.invalidateQueries({ queryKey: ["userRequests", adminId] });
      } else {
        errorNotify(res?.data?.message);
      }
    } catch (err) {
      errorNotify("Unexpected Error");
      console.log(err);
    } finally {
      setInTalkLoading(false);
    }
  };

  const handleNoteChange = (event) => {
    setError(false);
    setComment(event.target.value);
  };

  const closeModal = () => {
    setComment("");
    setError(false);
    setIsCommentSectionOpen(false);
    setRejectCommentUpdate(false);
  };

  const handleAction = (id, decision) => {
    setRequestedId(id);
    if (decision === "approve") {
      handleApproval(decision, id);
      setRevoking(true);
    } else {
      setIsCommentSectionOpen(true);
    }
    setRevoking(true);
    setShowRejectRevokeConfirmation(false);
  };

  const handleSaveComment = () => {
    if (comment.length > 15) {
      handleApproval("reject", requestedId);
      setIsCommentSectionOpen(false);
      setError(false);
      setComment("");
    } else {
      setError(true);
    }
  };

  const getTimeAgoLabel = (sentAt) => {
    const sentDate = new Date(sentAt);
    const now = new Date();
    const sentDay = new Date(
      sentDate.getFullYear(),
      sentDate.getMonth(),
      sentDate.getDate(),
    );
    const today = new Date(now.getFullYear(), now.getMonth(), now.getDate());
    const diffInDays = Math.floor((today - sentDay) / (1000 * 60 * 60 * 24));
    if (diffInDays === 0) return "Today";
    if (diffInDays === 1) return "Yesterday";
    if (diffInDays <= 3) return "3 days ago";
    if (diffInDays <= 7) return "1 week ago";
    if (diffInDays <= 14) return "2 weeks ago";
    if (diffInDays <= 30) return "1 month ago";
    if (diffInDays <= 60) return "2 months ago";
    if (diffInDays <= 90) return "3 months ago";
    if (diffInDays <= 180) return "6 months ago";
    return "Over 6 months ago";
  };

  const getDateBadgeColor = (sentAt) => {
    const sentDate = new Date(sentAt);
    const now = new Date();
    const sentDay = new Date(
      sentDate.getFullYear(),
      sentDate.getMonth(),
      sentDate.getDate(),
    );
    const today = new Date(now.getFullYear(), now.getMonth(), now.getDate());
    const diffInDays = Math.floor((today - sentDay) / (1000 * 60 * 60 * 24));
    if (diffInDays === 0) return "bg-lime-500";
    if (diffInDays === 1) return "bg-fuchsia-500";
    if (diffInDays <= 3) return "bg-blue-500";
    if (diffInDays <= 7) return "bg-yellow-500";
    if (diffInDays <= 14) return "bg-pink-700";
    if (diffInDays <= 30) return "bg-cyan-500";
    if (diffInDays <= 60) return "bg-teal-500";
    if (diffInDays <= 90) return "bg-red-500";
    if (diffInDays <= 180) return "bg-purple-600";
    return "bg-gray-500";
  };

  const handleRejectedReasonEdit = (comment, id) => {
    setComment(comment);
    setRequestedId(id);
    setIsCommentSectionOpen(true);
    setRejectCommentUpdate(true);
  };

  const activeStatus = (userData) => {
    if (
      userData?.hasOwnProperty("isActive") &&
      userData?.isActive &&
      userData?.profileCompleted
    ) {
      return "green-400";
    } else if (
      !userData?.hasOwnProperty("isActive") &&
      userData?.profileCompleted
    ) {
      return "green-400";
    } else if (userData?.profileCompletionPercentage > 0) {
      return "yellow-400";
    }
  };

  return (
    <div
      key={index}
      className="font-jost relative flex w-full flex-col items-center gap-2 rounded-xl bg-white p-2 shadow-md md:w-[30%] md:justify-around"
    >
      <div className="flex w-full flex-col items-center gap-2 p-2 md:justify-around xl:flex-row">
        <div className="flex flex-row justify-around">
          <div className="flex flex-col items-center text-center">
            <Link to={`/request-detail/${request?.requestedUser?._id}`}>
              <img
                src={
                  request?.requestedUser?.images.length > 0
                    ? DOBASEURL + request?.requestedUser?.images[0]
                    : request?.requestedUser?.gender === "male"
                      ? Images.MEN
                      : Images.WOMEN
                }
                className="h-20 w-20 cursor-pointer rounded-full border-4 border-yellow-200"
                alt="Requested User"
                onContextMenu={(e) => e.preventDefault()}
                onDragStart={(e) => e.preventDefault()}
              />
            </Link>
            <div className="flex flex-row items-center gap-1">
              <div
                className={`h-[10px] w-[10px] rounded-full bg-${activeStatus(request?.requestedUser)}`}
              ></div>
              <span className="scrollbar-hide relative w-[80px] overflow-x-auto whitespace-nowrap text-gray-700">
                {request?.requestedUser?.name}
              </span>
            </div>
          </div>
          <div className="flex">
            <MdDoubleArrow
              className="aria-hidden:true mt-5"
              style={{ fontSize: "40px", color: "#ffbb33" }}
            />
          </div>
          <div className="flex flex-col items-center text-center">
            <Link to={`/request-detail/${request?.user?._id}`}>
              <img
                src={
                  request?.user?.images.length > 0
                    ? DOBASEURL + request?.user?.images[0]
                    : request?.user?.gender === "male"
                      ? Images.MEN
                      : Images.WOMEN
                }
                className="h-20 w-20 cursor-pointer rounded-full border-4 border-yellow-200"
                alt="User"
                onContextMenu={(e) => e.preventDefault()}
                onDragStart={(e) => e.preventDefault()}
              />
            </Link>
            <div className="flex flex-row items-center gap-1">
              <span className="scrollbar-hide relative w-[80px] overflow-x-auto whitespace-nowrap text-gray-700">
                {request?.user?.name}
              </span>
              <div
                className={`h-[10px] w-[10px] rounded-full bg-${activeStatus(request?.user)}`}
              ></div>
            </div>
          </div>
        </div>

        {activeTab === 0 && canManage && (
          <div className="flex w-full flex-row items-center justify-center gap-3 lg:w-[20%] xl:flex-col">
            <button
              className={`right-24 top-4 rounded-full bg-green-500 px-2 py-2 text-xs text-white ${
                loadingAcceptRequestId === request._id
                  ? "cursor-not-allowed opacity-50"
                  : ""
              }`}
              onClick={() => handleAction(request?._id, "approve")}
              disabled={loadingAcceptRequestId === request?._id}
            >
              {loadingAcceptRequestId === request?._id ? (
                <Spinner />
              ) : (
                <FaUserCheck />
              )}
            </button>
            <button
              className={`right-4 top-4 rounded-full bg-red-500 px-2 py-2 text-xs text-white ${
                loadingDenyRequestId === request._id
                  ? "cursor-not-allowed opacity-50"
                  : ""
              }`}
              onClick={() => handleAction(request?._id, "reject")}
              disabled={loadingDenyRequestId === request?._id}
            >
              {loadingDenyRequestId === request?._id ? (
                <Spinner />
              ) : (
                <FaUserTimes />
              )}
            </button>
          </div>
        )}

        {activeTab === 2 && canManage && (
          <button
            className={`absolute right-2 top-2 rounded-full bg-blue-500 p-2 text-xs text-white shadow-md transition duration-300 hover:bg-blue-200 ${
              loadingDenyRequestId === request._id
                ? "cursor-not-allowed opacity-50"
                : ""
            }`}
            onClick={() => {
              setRequestedId(request?._id);
              setShowRejectRevokeConfirmation(true);
            }}
          >
            {loadingDenyRequestId === request?._id ? (
              <Spinner />
            ) : (
              <FaUserCheck />
            )}
          </button>
        )}

        {(activeTab === 1 || activeTab === 3) && canManage && (
          <button
            className={`absolute right-2 top-2 rounded-full bg-red-500 p-2 text-xs text-white shadow-md transition duration-300 hover:bg-red-200 ${
              loadingDenyRequestId === request._id
                ? "cursor-not-allowed opacity-50"
                : ""
            }`}
            onClick={() => handleAction(request?._id, "reject")}
            disabled={loadingDenyRequestId === request?._id}
          >
            {loadingDenyRequestId === request?._id ? (
              <Spinner />
            ) : (
              <FaUserTimes />
            )}
          </button>
        )}
      </div>

      <div className="flex w-fit items-center gap-2 rounded-lg border border-gray-200 bg-white p-2 text-xs text-gray-800 shadow-sm">
        <span className="inline-flex items-center gap-1 font-semibold">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            className="h-4 w-4 text-blue-500"
            viewBox="0 0 20 20"
            fill="currentColor"
          >
            <path
              fillRule="evenodd"
              d="M6 2a1 1 0 00-1 1v1H5a2 2 0 00-2 2v10a2 2 0 002 2h10a2 2 0 002-2V6a2 2 0 00-2-2h-.003V3a1 1 0 10-2 0v1H7V3a1 1 0 00-1-1zM5 8h10v8H5V8z"
              clipRule="evenodd"
            />
          </svg>
          Proposal Date:
        </span>
        <span className="font-normal text-black">
          {request?.sentAt
            ? new Date(request?.sentAt).toLocaleDateString("en-GB")
            : "N/A"}
        </span>
        {request?.sentAt && (
          <span
            className={`ml-2 flex items-center gap-1 rounded-full px-2 py-0.5 text-[10px] font-medium text-white shadow-sm ${getDateBadgeColor(
              request?.sentAt,
            )}`}
          >
            <MdHistory className="text-[12px]" />
            {getTimeAgoLabel(request?.sentAt)}
          </span>
        )}
      </div>

      {/* Status Info */}
      <div className="w-full px-4 text-left">
        {/* "Pending In Talk" is now tab index 6 -- a new "User Requests" tab was inserted at index 4. */}
        {request?.requestStatus !== "Pending" && activeTab !== 6 && (
          <>
            <p className="text-bg-black text-left text-xs font-semibold">
              {request?.requestStatus === "Rejected"
                ? "Declined By:"
                : "Accepted By:"}
              <span className="font-normal">
                {request?.requestStatus === "Rejected"
                  ? request?.rejectedBy
                  : request?.approvedBy}
              </span>
            </p>
            <p className="text-bg-black text-xs font-semibold">
              {request?.requestStatus === "Rejected"
                ? "Admin Declined Date:"
                : "Admin Accepted Date:"}{" "}
              <span className="font-normal">
                {request?.requestStatus === "Rejected"
                  ? request?.adminRejectedAt
                    ? new Date(request?.adminRejectedAt).toLocaleDateString(
                        "en-GB",
                      )
                    : "N/A"
                  : request?.adminApprovedAt
                    ? new Date(request?.adminApprovedAt).toLocaleDateString(
                        "en-GB",
                      )
                    : "N/A"}
              </span>
            </p>
          </>
        )}

        {request?.requestStatus === "Accepted" &&
          request?.adminApproval === true &&
          request?.userApproval === true && (
            <div className="text-left text-xs font-semibold">
              <p className="text-bg-black">
                User Approved Date:{" "}
                <span className="font-normal">
                  {request?.userApprovedAt
                    ? new Date(request?.userApprovedAt).toLocaleDateString(
                        "en-GB",
                      )
                    : "N/A"}
                </span>
              </p>
              <div className="mt-2 flex justify-center">
                <p
                  className={`w-fit rounded px-2 py-1 text-center text-xs font-medium ${
                    request?.requestedUserViewprofile &&
                    request?.userViewprofile
                      ? "bg-green-100 text-green-700"
                      : request?.requestedUserViewprofile ||
                          request?.userViewprofile
                        ? "bg-yellow-100 text-yellow-700"
                        : "bg-red-100 text-red-700"
                  }`}
                >
                  {request?.requestedUserViewprofile && request?.userViewprofile
                    ? "Both users viewed the profile"
                    : request?.requestedUserViewprofile
                      ? `${request?.requestedUser?.name} viewed the profile`
                      : request?.userViewprofile
                        ? `${request?.user?.name} viewed the profile`
                        : "No user has viewed the profile yet"}
                </p>
              </div>
            </div>
          )}

        {(request?.requestStatus === "Rejected" ||
          (request?.adminApproval === true &&
            request?.userReject === true)) && (
          <>
            <p className="text-bg-black text-left text-xs font-semibold">
              User Declined Date:{" "}
              <span className="font-normal">
                {request?.userRejectedAt
                  ? new Date(request.userRejectedAt).toLocaleDateString("en-GB")
                  : "N/A"}
              </span>
            </p>
            <div className="relative flex items-center gap-2">
              {!isCommentSectionOpen ? (
                <>
                  <p className="text-bg-black whitespace-nowrap text-xs font-semibold">
                    Declined Reason:
                  </p>
                  <p className="max-w-[15rem] truncate text-xs font-normal text-red-500">
                    {request?.comments || "N/A"}
                  </p>
                  {canManage && (
                    <button
                      onClick={() =>
                        handleRejectedReasonEdit(request?.comments, request._id)
                      }
                      className="ml-2 text-blue-500 hover:text-blue-700"
                    >
                      <FaEdit />
                    </button>
                  )}
                </>
              ) : null}
            </div>
          </>
        )}
      </div>

      {canManage &&
        (activeTab !== 6 ? (
          <button
            className="cursor-pointer text-xs text-blue-500 hover:underline disabled:opacity-50"
            onClick={() => handleInTalk(true)}
            disabled={inTalkLoading}
          >
            {inTalkLoading ? <Spinner size={3} /> : "In Talk With User"}
          </button>
        ) : (
          <button
            className="cursor-pointer text-xs text-red-500 hover:underline disabled:opacity-50"
            onClick={() => handleInTalk(false)}
            disabled={inTalkLoading}
          >
            {inTalkLoading ? <Spinner size={3} /> : "Revoke"}
          </button>
        ))}

      <p className="text-xs text-gray-400">Click profile to see full details</p>

      {isCommentSectionOpen && (
        <div className="popup-container fixed left-0 top-0 z-50 flex h-full w-full items-center justify-center bg-black bg-opacity-50">
          <RejectModel
            setComment={setComment}
            comment={comment}
            handleNoteChange={handleNoteChange}
            closeModal={closeModal}
            error={error}
            handleSaveComment={handleSaveComment}
            isShowDropdown={true}
          />
        </div>
      )}

      {showRejectRevokeConfirmation && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
          <div className="w-[90%] rounded-lg bg-white p-4 shadow-lg sm:w-[60%] md:w-[40%]">
            <p className="mb-4 text-center text-sm sm:text-base">
              {Strings.REJECT_REVOKE_USER}
            </p>
            <div className="flex justify-around">
              <button
                onClick={() => handleAction(request?._id, "approve")}
                className="rounded bg-blue-500 px-4 py-2 text-white"
                disabled={revoking}
              >
                {revoking ? <Spinner size="small" /> : "Yes, Revoke"}
              </button>
              <button
                onClick={() => {
                  setRequestedId(null);
                  setShowRejectRevokeConfirmation(false);
                }}
                className="rounded bg-gray-300 px-4 py-2"
              >
                Cancel
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

const UserRequest = () => {
  const adminId = getValueFromLocalStorage(localStorageKey.USERDATA, "adminId");

  const [userRequestData, setUserRequestData] = useState([]);
  const [acceptedRequest, setAcceptedRequest] = useState([]);
  const [rejectedRequest, setRejectedRequest] = useState([]);
  const [mutuallyAcceptedRequest, setMutuallyAcceptedRequest] = useState([]);
  const [userRejectedRequest, setUserRejectedRequest] = useState([]);
  const [pendingInTalkRequest, setPendingInTalkRequest] = useState([]);
  const [activeTab, setActiveTab] = useState(0);
 const [searchQuery, setSearchQuery] = useState("");
  const [showAdvanceSearch, setShowAdvanceSearch] = useState(false);  const [filter, setFilter] = useState("all");
  const [requests, setRequests] = useState([]);

  const setters = {
    setUserRequestData,
    setAcceptedRequest,
    setRejectedRequest,
    setMutuallyAcceptedRequest,
    setUserRejectedRequest,
    setPendingInTalkRequest,
  };

  const { isLoading: loading, data: fetchedData } = useQuery({
    queryKey: ["userRequests", adminId],
    queryFn: async () => {
      const res = await authorizedGet(
        `${configuration.apis.adminApprovalPending}?adminId=${adminId}`,
        config,
      );
      if (res?.data?.status) {
        return res.data.data;
      } else {
        errorNotify(res?.data?.message);
        return [];
      }
    },
    enabled: !!adminId,
    staleTime: 1000 * 60 * 2,
    retry: false,
  });

  useEffect(() => {
    if (!fetchedData) return;
    setRequests(fetchedData);
    processAndSetData(fetchedData, setters);
  }, [fetchedData]);

  const [qnUserRequests, setQnUserRequests] = useState([]);
  const [qnAcceptedRequest, setQnAcceptedRequest] = useState([]);
  const [qnRejectedRequest, setQnRejectedRequest] = useState([]);
  const [qnMutuallyAcceptedRequest, setQnMutuallyAcceptedRequest] = useState([]);
  const [qnAdminMutuallyReject, setQnAdminMutuallyReject] = useState([]);
  const [qnPendingInTalkRequest, setQnPendingInTalkRequest] = useState([]);

  const { isLoading: questionnaireLoading, data: questionnaireData } = useQuery({
    queryKey: [QUESTIONNAIRE_REQUESTS_KEY, adminId],
    queryFn: async () => {
      const res = await authorizedGet(
        `${configuration.apis.getAllQuestionnaireRequests}?adminId=${adminId}`,
        config,
      );
      if (res?.data?.status) {
        return res.data.requests;
      } else {
        errorNotify(Strings.ERROR);
        return [];
      }
    },
    enabled: !!adminId,
    staleTime: 0,
    retry: false,
  });

  const processQuestionnaireData = (data) => {
    const users = [];
    const accepted = [];
    const rejected = [];
    const mutuallyAccepted = [];
    const mutuallyAdminReject = [];
    const pendingInTalk = [];

    data.forEach((value) => {
      if (value?.inTalk === true) {
        pendingInTalk.push(value);
      } else if (value?.adminApproval === "pending") {
        users.push(value);
      } else if (value?.overAllAdminDecision === "rejected") {
        mutuallyAdminReject.push(value);
      } else if (value?.adminApproval === "approved") {
        if (value?.userApproval === "approved") {
          mutuallyAccepted.push(value);
        } else {
          accepted.push(value);
        }
      } else if (value?.adminApproval === "rejected") {
        rejected.push(value);
      }
    });

    setQnUserRequests(users);
    setQnAcceptedRequest(accepted);
    setQnRejectedRequest(rejected);
    setQnMutuallyAcceptedRequest(mutuallyAccepted);
    setQnAdminMutuallyReject(mutuallyAdminReject);
    setQnPendingInTalkRequest(pendingInTalk);
  };

  useEffect(() => {
    if (!questionnaireData) return;
    processQuestionnaireData(questionnaireData);
  }, [questionnaireData]);


  useEffect(() => {
    const savedTab = parseInt(localStorage.getItem("activeTab")) || 0;
    const savedQuery = localStorage.getItem("searchQuery") || "";
    const savedSearchVisible =
      localStorage.getItem("showAdvanceSearch") === "true";

    setActiveTab(savedTab);
    setSearchQuery(savedQuery);
    setShowAdvanceSearch(savedSearchVisible);
  }, []);

  const handleTabClick = (index) => {
    setActiveTab(index);
    localStorage.setItem("activeTab", index);
  };

 const handleAdvanceSearch = (
    searchValue,
    data = requests,
    tab = activeTab,
  ) => {
    const query = searchValue.toLowerCase().trim();
    setSearchQuery(query);
    localStorage.setItem("searchQuery", query);
    setShowAdvanceSearch(true);
    localStorage.setItem("showAdvanceSearch", "true");

    const filterFunc = (list) =>
      list.filter((user) => {
        const userName = user?.user?.name?.toLowerCase() || "";
        const requestedUserName =
          user?.requestedUser?.name?.toLowerCase() || "";
        return userName.includes(query) || requestedUserName.includes(query);
      });
    if (tab === 0) {
      setUserRequestData(
        filterFunc(
          data.filter((d) => d.requestStatus === "Pending" && !d.inTalk),
        ),
      );
    } else if (tab === 1) {
      setAcceptedRequest(
        filterFunc(
          data.filter(
            (d) =>
              d.requestStatus === "Accepted" &&
              (d.adminApproval !== true || d.userApproval !== true) &&
              d.userReject !== true &&
              !d.inTalk,
          ),
        ),
      );
    } else if (tab === 2) {
      setRejectedRequest(
        filterFunc(
          data.filter((d) => d.requestStatus === "Rejected" && !d.inTalk),
        ),
      );
    } else if (tab === 3) {
      setMutuallyAcceptedRequest(
        filterFunc(
          data.filter(
            (d) =>
              d.requestStatus === "Accepted" &&
              d.adminApproval === true &&
              d.userApproval === true &&
              !d.inTalk,
          ),
        ),
      );
    } else if (tab === 4) {
      // "User Requests" -- questionnaire data lives in a separate query/state domain.
      setQnUserRequests(
        filterFunc(
          (questionnaireData || []).filter(
            (d) => d?.adminApproval === "pending" && !d?.inTalk,
          ),
        ),
      );
    } else if (tab === 5) {
      setUserRejectedRequest(
        filterFunc(
          data.filter(
            (d) =>
              d.adminApproval === true && d.userReject === true && !d.inTalk,
          ),
        ),
      );
    } else if (tab === 6) {
      setPendingInTalkRequest(
        filterFunc(data.filter((d) => d.inTalk === true)),
      );
    }
  };

  const toggleSearchBar = () => {
    const newValue = !showAdvanceSearch;
    if (!newValue) {
      setSearchQuery("");
      localStorage.removeItem("searchQuery");
      setFilter("all");
      processAndSetData(requests, setters);
      if (questionnaireData) processQuestionnaireData(questionnaireData);
    }
    setShowAdvanceSearch(newValue);
    localStorage.setItem("showAdvanceSearch", String(newValue));
  };

  const filterRequests = (
    value,
    customStartDate = null,
    customEndDate = null,
  ) => {
    const today = new Date();
    const currentYear = today.getFullYear();
    setFilter(value);

    if (activeTab === 4) {
      let qData = [...(questionnaireData || [])];

      if (searchQuery?.trim()?.length > 0) {
        const query = searchQuery.toLowerCase().trim();
        qData = qData.filter((user) => {
          const userName = user?.user?.name?.toLowerCase() || "";
          const requestedUserName = user?.requestedUser?.name?.toLowerCase() || "";
          return userName.includes(query) || requestedUserName.includes(query);
        });
      }

      if (value !== "all") {
        const currentQYear = today.getFullYear();
        qData = qData.filter((user) => {
          if (!user?.sentAt) return false;
          const requestDate = new Date(user.sentAt);
          const diffDays =
            (today.getTime() - requestDate.getTime()) / (1000 * 60 * 60 * 24);
          const month = requestDate.getMonth();
          const year = requestDate.getFullYear();
          if (value === "today")
            return requestDate.toDateString() === today.toDateString();
          if (value === "week") return diffDays < 7 && diffDays >= 0;
          if (value === "month")
            return month === today.getMonth() && year === today.getFullYear();
          if (value === "year") return year === today.getFullYear();
          if (value === "q1") return month <= 2 && year === currentQYear;
          if (value === "q2")
            return month >= 3 && month <= 5 && year === currentQYear;
          if (value === "q3")
            return month >= 6 && month <= 8 && year === currentQYear;
          if (value === "q4") return month >= 9 && year === currentQYear;
          if (value === "h1") return month <= 5 && year === currentQYear;
          if (value === "h2") return month >= 6 && year === currentQYear;
          return false;
        });
      }

      qData.sort((a, b) => new Date(b.sentAt) - new Date(a.sentAt));
      processQuestionnaireData(qData);
      return;
    }

    let data = [...requests];

    if (searchQuery?.trim()?.length > 0) {
      const query = searchQuery.toLowerCase().trim();
      data = data.filter((user) => {
        const userName = user?.user?.name?.toLowerCase() || "";
        const requestedUserName =
          user?.requestedUser?.name?.toLowerCase() || "";
        return userName.includes(query) || requestedUserName.includes(query);
      });
    }

    const isDateBasedFilter = [
      "today",
      "week",
      "month",
      "year",
      "q1",
      "q2",
      "q3",
      "q4",
      "h1",
      "h2",
      "custom",
    ].includes(value);

    if (isDateBasedFilter) {
      let startDate, endDate;
      switch (value) {
        case "today":
          startDate = new Date(today.setHours(0, 0, 0, 0));
          endDate = new Date();
          break;
        case "week":
          startDate = new Date();
          startDate.setDate(today.getDate() - 6);
          endDate = new Date();
          break;
        case "month":
          startDate = new Date(currentYear, today.getMonth(), 1);
          endDate = new Date();
          break;
        case "year":
          startDate = new Date(currentYear, 0, 1);
          endDate = new Date();
          break;
        case "q1":
          startDate = new Date(currentYear, 0, 1);
          endDate = new Date(currentYear, 2, 31);
          break;
        case "q2":
          startDate = new Date(currentYear, 3, 1);
          endDate = new Date(currentYear, 5, 30);
          break;
        case "q3":
          startDate = new Date(currentYear, 6, 1);
          endDate = new Date(currentYear, 8, 30);
          break;
        case "q4":
          startDate = new Date(currentYear, 9, 1);
          endDate = new Date(currentYear, 11, 31);
          break;
        case "h1":
          startDate = new Date(currentYear, 0, 1);
          endDate = new Date(currentYear, 5, 30);
          break;
        case "h2":
          startDate = new Date(currentYear, 6, 1);
          endDate = new Date(currentYear, 11, 31);
          break;
        case "custom":
          if (customStartDate && customEndDate) {
            startDate = new Date(customStartDate);
            endDate = new Date(customEndDate);
          } else {
            console.warn("Custom range requires start and end date.");
            return;
          }
          break;
        default:
          break;
      }
      data = data.filter((user) => {
        const requestDate = new Date(user?.sentAt);
        return requestDate >= startDate && requestDate <= endDate;
      });
    }

    data.sort((a, b) => new Date(b.sentAt) - new Date(a.sentAt));

    if (activeTab === 3) {
      let filtered = data.filter(
        (d) =>
          d.requestStatus === "Accepted" &&
          d.adminApproval === true &&
          d.userApproval === true &&
          !d.inTalk,
      );
      if (value === "userViewed") {
        filtered = filtered.filter(
          (req) => req.userViewprofile && !req.requestedUserViewprofile,
        );
      } else if (value === "requestedUserViewed") {
        filtered = filtered.filter(
          (req) => !req.userViewprofile && req.requestedUserViewprofile,
        );
      } else if (value === "bothViewed") {
        filtered = filtered.filter(
          (req) => req.userViewprofile && req.requestedUserViewprofile,
        );
      } else if (value === "noneViewed") {
        filtered = filtered.filter(
          (req) => !req.userViewprofile && !req.requestedUserViewprofile,
        );
      }
      filtered.sort((a, b) => new Date(b.sentAt) - new Date(a.sentAt));
      setMutuallyAcceptedRequest(filtered);
    } else {
      processAndSetData(data, setters);
    }
  };

  
  const tabList = [
    { name: "User Proposal", count: userRequestData.length },
    { name: "Admin Accepted", count: acceptedRequest.length },
    { name: "Admin Declined", count: rejectedRequest.length },
    {
      name: "Mutually Accepted Proposal",
      count: mutuallyAcceptedRequest.length,
    },
    { name: "Questionnaire Requests", count: qnUserRequests.length },
    { name: "User Declined Proposal", count: userRejectedRequest.length },
    { name: "Pending In Talk With User", count: pendingInTalkRequest.length },
  ];

  const renderCards = (dataList) =>
    dataList.map((item, index) => (
      <RequestCards
        key={item._id || index}
        request={item}
        activeTab={activeTab}
        index={index}
        adminId={adminId}
        setUserRequestData={setUserRequestData}
        setAcceptedRequest={setAcceptedRequest}
        setRejectedRequest={setRejectedRequest}
        setMutuallyAcceptedRequest={setMutuallyAcceptedRequest}
        setUserRejectedRequest={setUserRejectedRequest}
        setRequests={setRequests}
        setPendingInTalkRequest={setPendingInTalkRequest}
      />
    ));

  const tabContent = [
    { data: userRequestData, empty: "No User Proposal Available." },
    { data: acceptedRequest, empty: "No Accepted Proposal Available." },
    { data: rejectedRequest, empty: "No Declined Proposal Available." },
    {
      data: mutuallyAcceptedRequest,
      empty: "No Mutually Accepted Proposal Available.",
    },
    {
      data: qnUserRequests,
      empty: "No Questionnaire requests available.",
      type: "questionnaire",
    },
    {
      data: userRejectedRequest,
      empty: "No User Declined Proposal Available.",
    },
    {
      data: pendingInTalkRequest,
      empty: "No Pending In Talk Proposal Available.",
    },
  ];

  return (
    <div className="font-jost relative ml-4 h-auto rounded-lg p-2">
      <div className="flex w-full items-center justify-center text-xs text-gray-400 md:justify-end">
        Note: The details are sorted by the date the request was sent.
      </div>

      <div className="flex w-full flex-col justify-between border-b border-gray-300 md:flex-row">
        <ul className="flex flex-col justify-center md:flex-row">
          {tabList.map((list, index) => (
            <li
              key={index}
              className={`mt-3 cursor-pointer px-4 py-2 text-center text-textGreen transition-all ${
                showAdvanceSearch
                  ? "text-[13px] xl:text-[16px]"
                  : "sm:text-xs md:text-base"
              } ${
                activeTab === index
                  ? "border-b-2 border-textYellow text-textYellow"
                  : "hover:bg-gray-100 hover:text-textYellow"
              }`}
              onClick={() => handleTabClick(index)}
            >
              {list.name}({list.count})
            </li>
          ))}
        </ul>

        <div className="flex flex-wrap items-center justify-center">
          <div className="flex flex-row items-center gap-2">
            <div className="flex items-center rounded-lg">
              {!showAdvanceSearch ? (
                <IoIosSearch
                  className="cursor-pointer text-xl text-gray-500 sm:text-2xl"
                  onClick={toggleSearchBar}
                />
              ) : (
                <div className="flex items-center gap-2">
                  <AdvanceSearch
                    searchQuery={searchQuery}
                    onSearchValue={handleAdvanceSearch}
                  />
                  <ImCancelCircle
                    className="cursor-pointer text-lg text-gray-500 sm:text-xl"
                    onClick={toggleSearchBar}
                  />
                </div>
              )}
            </div>
            <div className="flex flex-col items-center">
              <p className="text-xs">sort by:</p>
              <select
                className="rounded-md border px-1 py-1 text-xs"
                value={filter}
                onChange={(e) => filterRequests(e.target.value)}
              >
                <option value="all">All</option>
                <option value="today">Today</option>
                <option value="week">This Week</option>
                <option value="month">This Month</option>
                <option value="year">This Year</option>
                <option value="q1">Q1 (Jan - Mar)</option>
                <option value="q2">Q2 (Apr - Jun)</option>
                <option value="q3">Q3 (Jul - Sep)</option>
                <option value="q4">Q4 (Oct - Dec)</option>
                <option value="h1">H1 (Jan - Jun)</option>
                <option value="h2">H2 (Jul - Dec)</option>
                {activeTab === 3 && (
                  <>
                    <option value="userViewed">User Viewed</option>
                    <option value="requestedUserViewed">
                      Requested User Viewed
                    </option>
                    <option value="bothViewed">Both Viewed</option>
                    <option value="noneViewed">None Viewed</option>
                  </>
                )}
              </select>
            </div>
          </div>
        </div>
      </div>

      {tabContent.map((tab, index) =>
        activeTab === index ? (
          <div key={index}>
            {(tab.type === "questionnaire" ? questionnaireLoading : loading) ? (
              <div className="flex min-h-screen flex-col items-center justify-center">
                <Spinner />
              </div>
            ) : tab.data.length > 0 ? (
              <div className="flex flex-wrap gap-4 p-2">
                {tab.type === "questionnaire"
                  ? tab.data.map((request) => (
                      <UserRequestCard
                        key={request?._id}
                        user={request?.user}
                        requestedUser={request?.requestedUser}
                        // Hardcoded to 0 so this card renders/behaves exactly like
                        // the "User Requests" tab on the Questionnaire Request page,
                        // regardless of this tab's actual index on this page.
                        activeTab={0}
                        reqId={request?._id}
                        sentAt={request?.sentAt}
                        approvalAdminId={request?.approvalAdminId}
                        adminApprovedAt={request?.adminApprovedAt}
                        comments={request?.comments}
                        userApprovalAt={request?.userApprovalAt}
                        overAllAdminDecision={request?.overAllAdminDecision}
                        overAllAdminDecisionAt={request?.overAllAdminDecisionAt}
                        overAllAdmincomments={request?.overAllAdmincomments}
                        overAllAdminId={request?.overAllAdminId}
                        setUserRequests={setQnUserRequests}
                        setAcceptedRequest={setQnAcceptedRequest}
                        setRejectedRequest={setQnRejectedRequest}
                        setMutuallyAcceptedRequest={setQnMutuallyAcceptedRequest}
                        setAdminMutuallyReject={setQnAdminMutuallyReject}
                        setPendingInTalkRequest={setQnPendingInTalkRequest}
                        inTalkFromTab={request?.inTalkFromTab}
                      />
                    ))
                  : renderCards(tab.data)}
              </div>
            ) : (
              <div className="flex flex-col items-center justify-center p-2">
                <h4 className="text-black">{tab.empty}</h4>
              </div>
            )}
          </div>
        ) : null,
      )}

      <MessageBar />
    </div>
  );
};

export default UserRequest;
